<script setup lang="ts">
import BotChatMessageLayout from './layouts/BotChatMessageLayout.vue';
import SpeechBalloon from 'theme/components/molecules/SpeechBalloon.vue';
</script>

<template>
  <BotChatMessageLayout>
    <template #message>
      <SpeechBalloon>
        <slot />
      </SpeechBalloon>
    </template>
  </BotChatMessageLayout>
</template>
